<template>
  <section class="heroheader">
    <div class="heroheader-inner">
      <h1
        v-if="heroTitle"
        class="heroheader-title"
      >
        {{ heroTitle }}
      </h1>
      <p
        v-if="heroSubtitle"
        class="heroheader-subtitle"
      >
        {{ heroSubtitle }}
      </p>
      <a
        v-if="heroLink"
        :href="heroLink.href"
        class="btn btn-primary"
      >{{ heroLink.label }}</a>
    </div>
    <img
      class="heroheader-image"
      :src="heroImage"
      alt=""
      aria-hidden="true"
    >
  </section>
</template>

<script>
import TailwindMixin from '@/mixins/TailwindMixin';

export default {
  name: 'HeroHeader',
  mixins: [TailwindMixin],
  props: {
    heroImageMobile: {
      type: String,
      default: '',
    },
    heroImageLarge: {
      type: String,
      default: '',
    },
    heroTitle: {
      type: String,
      default: '',
    },
    heroSubtitle: {
      type: String,
      default: '',
    },
    heroLink: {
      type: Object,
      default: null,
    },
  },
  computed: {
    heroImage() {
      if (this.doesWindowHaveMinWidthXs) {
        return this.heroImageLarge;
      }
      return this.heroImageMobile;
    },
  },
};
</script>

<style lang="postcss" scoped>
.heroheader {
  @apply w-full flex flex-col justify-center pb-8 relative bg-primary-bravo;
  min-height: 500px;

  @screen md {
    min-height: 575px;
  }

  &::before {
    @apply block w-full h-full bg-bottom bg-contain bg-no-repeat absolute z-20;
    content: '';
    /* background-image: url('~@/assets/images/curve-header.svg'); */
    bottom: -1px;
  }

  &-image {
    @apply absolute w-full h-full opacity-80 object-cover z-10 top-0 left-0;
  }

  &-title {
    @apply text-white font-playfair text-left text-8xl mb-8 font-bold;
    text-shadow: 0 2px 2px rgba(0, 0, 0, 0.65);

    @screen xl {
      @apply text-9xl;
    }
  }

  &-subtitle {
    @apply text-white text-left font-bold text-xl mb-8;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);

    @screen md {
      @apply text-2xl;
    }

    @screen lg {
      @apply text-3xl;
    }

    @screen xl {
      @apply text-4xl;
    }
  }

  &-inner {
    @apply mx-auto relative z-20 container max-w-5xl pl-5 md:pl-4 pr-12 md:pr-96 overflow-hidden;
  }
}
</style>
